module.exports = __webpack_public_path__ + "img/pc-textlink-04.7ed7fb0c.svg";